import { Link, useNavigate } from "react-router-dom";
import { ScanFace, LogOut, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

export function AdminShell({ children }) {
  const nav = useNavigate();
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("admin_token");
    nav("/admin/login");
  };
  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="bg-white border-b border-zinc-200">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-2" data-testid="admin-home-link">
            <span className="w-8 h-8 bg-[#0055FF] text-white grid place-items-center rounded-md"><ScanFace className="w-5 h-5" /></span>
            <span className="font-display font-extrabold text-lg">GO-CLICK <span className="font-light text-zinc-500">Admin</span></span>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/" data-testid="admin-view-site-link" className="h-9 px-3 rounded-md border border-zinc-200 text-sm flex items-center gap-1.5 hover:border-zinc-900"><ExternalLink className="w-4 h-4" /><span className="hidden sm:inline">Ver site</span></Link>
            <button onClick={logout} data-testid="admin-logout-btn" className="h-9 px-3 rounded-md border border-zinc-200 text-sm flex items-center gap-1.5 hover:border-zinc-900"><LogOut className="w-4 h-4" /><span className="hidden sm:inline">Sair</span></button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-5 sm:px-8 py-8">{children}</main>
    </div>
  );
}
